import React, { useRef, useState } from "react";
import { getOSSImage } from './Utils'

import '../css/AppInfo.css';

const fullImage = getOSSImage('yingyongjianjie_quan.png');
const appDownloadImage = getOSSImage('zhutu_apppxiazai.png');
const titleImage = getOSSImage('zi_title_yingyongjianjie.png');
const playButton = getOSSImage('b_bofang.png');
const videoPreview = getOSSImage("preview.png");

export default function AppInfo() {

    const [isPlaying, SetIsPlaying] = useState(false);
    const [played, SetPlayed] = useState(false);
    const videoPlayer = useRef<any>(null);

    const playVideo = () => {
        if (videoPlayer.current) {
            videoPlayer.current.play();
            SetIsPlaying(true);
            SetPlayed(true);
        }
    }

    const tryPauseVideo = () => {
        if (isPlaying && videoPlayer.current) {
            videoPlayer.current.pause();
            SetIsPlaying(false);
        }
    }

    return (
        <div id="appinfo" className="info-container">
            <video onClick={tryPauseVideo} className="app-video" ref={videoPlayer} controls={false} onEnded={() => SetIsPlaying(false)}>
                <source src="https://oss.animepop.net/videos/welcome_video.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
            <img className="app-info-full-image" alt="app-info-full" src={fullImage}/>
            <img className="download-image" alt="download-image" src={appDownloadImage}/>
            <img className="app-info-title" alt="app-info-title" src={titleImage}/>
            <img className="app-video-preview" alt='preview' src={videoPreview} style={{display: played ? 'none' : 'block'}}/>
            <img 
                className="play-button" 
                alt="play" 
                src={playButton} 
                onClick={playVideo}
                style={{display: isPlaying ? 'none' : 'block'}}
            />
        </div>
    );
}